import { render, staticRenderFns } from "./SwitchesFlat.vue?vue&type=template&id=3336d6e0&"
import script from "./SwitchesFlat.vue?vue&type=script&lang=js&"
export * from "./SwitchesFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports